'use client'
import '@dynamic-labs-sdk/client/core';
import '@dynamic-labs/sdk-api-core';
import 'react';
import '@dynamic-labs-sdk/client';
import '../../../../client/client.js';
import '../../../../../../_virtual/_tslib.js';
import '../../../../events/dynamicEvents.js';
import '@dynamic-labs/utils';
import '../../../../store/state/projectSettings/projectSettings.js';
import '../../../constants/values.js';
import { getUserProfile } from '../../../../client/extension/user/getUserProfile/getUserProfile.js';
import { getAuthMode } from '../../../../store/state/authMode/authMode.js';

const isConnectOnly = () => {
    const authMode = getAuthMode();
    const user = getUserProfile();
    // we need to check for user because of connect-only (authenticated)
    // and linking a new wallet in mutliwallet
    const linking = user !== undefined;
    const connectOnly = authMode === 'connect-only' && !linking;
    return connectOnly;
};

export { isConnectOnly };
